import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { jwtDecode } from "jwt-decode";
import "../styles/Hall.css";
const apiUrl = process.env.REACT_APP_API_URL;

function Hall() {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [user, setUser] = useState(null);
  const [empresas, setEmpresas] = useState([]);
  const [solicitacoes, setSolicitacoes] = useState([]);

  useEffect(() => {
    try {
      const decodedToken = jwtDecode(token);
      setUser(decodedToken);
    } catch (error) {
      console.error("Invalid token:", error);
      navigate("/login");
    }

    const fetchEmpresas = async () => {
      try {
        const response = await fetch(
          `${apiUrl}admins/empresas`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 404) {
          setEmpresas([]);
          return;
        }

        if (!response.ok) {
          throw new Error("Failed to fetch empresas");
        }

        const data = await response.json();
        setEmpresas(data);
      } catch (error) {
        console.error("Error fetching empresas:", error);
      }
    };

    const fetchSolicitacoes = async () => {
      try {
        const response = await fetch(
          `${apiUrl}admins/solicitacoes/pendentes`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 404) {
          setSolicitacoes([]);
          return;
        }

        if (!response.ok) {
          throw new Error("Failed to fetch solicitacoes");
        }

        const data = await response.json();
        const solicitacoesPendentes = await Promise.all(
          data.map(async (solicitacao) => {
            try {
              const empresaResponse = await fetch(
                `${apiUrl}empresas/${solicitacao.id_empresa}`
              );
              const empresaData = await empresaResponse.json();
              return {
                ...solicitacao,
                nome_empresa: empresaData.nome,
              };
            } catch (error) {
              console.error("Error fetching empresa:", error);
              return solicitacao;
            }
          })
        );
        setSolicitacoes(solicitacoesPendentes);
      } catch (error) {
        console.error("Error fetching solicitacoes:", error);
      }
    };

    fetchEmpresas();
    fetchSolicitacoes();

    const intervalId = setInterval(() => {
      fetchEmpresas();
      fetchSolicitacoes();
    }, 60000);

    // Limpar o intervalo quando o componente for desmontado
    return () => clearInterval(intervalId);
  }, [token, navigate]);

  const handleSolicitarAdicaoEmpresa = async () => {
    try {
      const response = await fetch(
        `${apiUrl}admins/solicitacoes-permissao-empresa`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 404) {
        const decodedToken = jwtDecode(token);
        const id_adm = decodedToken.id; // Supondo que o ID do administrador está no token

        const response = await fetch(
          `${apiUrl}admins/solicitar-adicao-empresa`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ id_adm }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to send request");
        }

        alert("Solicitação enviada");
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch solicitacoes");
      }

      const data = await response.json();

      if (
        data.length === 0 ||
        data[0].status === "concluida" ||
        data[0].status === "recusada"
      ) {
        const decodedToken = jwtDecode(token);
        const id_adm = decodedToken.id; // Supondo que o ID do administrador está no token

        const response = await fetch(
          `${apiUrl}admins/solicitar-adicao-empresa`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ id_adm }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to send request");
        }

        alert("Solicitação enviada");
      } else if (data[0].status === "pendente") {
        alert("Você já tem uma solicitação pendente, aguarde por favor");
      } else if (data[0].status === "aprovada") {
        navigate("/create-company");
      }
    } catch (error) {
      console.error("Error fetching solicitacoes:", error);
      alert("Erro ao verificar solicitações");
    }
  };

  const handleEntrarEmpresa = (empresaId) => {
    navigate("/map", { state: { empresaId } });
  };

  const handleResponderSolicitacao = async (solicitacaoId, status) => {
    try {
      const response = await fetch(
        `${apiUrl}admins/responder-acesso-adm`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ id_solicitacao: solicitacaoId, status }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to respond to solicitation");
      }

      alert(`Solicitação ${status}`);
      // Atualizar a lista de solicitações após responder
      const updatedSolicitacoes = solicitacoes.filter(
        (solicitacao) => solicitacao.id !== solicitacaoId
      );
      setSolicitacoes(updatedSolicitacoes);
    } catch (error) {
      console.error("Error responding to solicitation:", error);
      alert("Erro ao responder solicitação");
    }
  };

  return (
    <div className="hall-container">
      <h2>Olá {user?.nome}, bem vindo!</h2>
      <div className="hall-content">
        <div className="hall-box">
          <h3>Sua Empresa</h3>
          {empresas.length > 0 ? (
            <div>
              {empresas.map((empresa) => (
                <div key={empresa.id} className="empresa-item">
                  <span>{empresa.nome}</span>
                  <button 
                  className="solicitar-button" 
                  onClick={() => handleEntrarEmpresa(empresa.id)}>
                    Entrar
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <p>Nenhuma empresa encontrada</p>
          )}
        </div>
        <div className="hall-box">
          <h3>Suas Solicitações</h3>
          {solicitacoes.length > 0 ? (
            <div>
              {solicitacoes.map((solicitacao) => (
                <div key={solicitacao.id} className="solicitacao-item">
                  <span>{solicitacao.nome_empresa}</span>
                  <button
                    className="accept-button"
                    onClick={() =>
                      handleResponderSolicitacao(solicitacao.id, "aceita")}>Aceitar
                  </button>
                  <button
                    className="reject-button"
                    onClick={() =>
                      handleResponderSolicitacao(solicitacao.id, "recusada")
                    }>Recusar
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <p>Nenhuma solicitação encontrada</p>
          )}
        </div>
      </div>
      <p>
        Deseja cadastrar sua Empresa?{" "}
        <button
          className="solicitar-button"
          onClick={handleSolicitarAdicaoEmpresa}>Clique aqui
        </button>
      </p>
    </div>
  );
}

export default Hall;